import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DebounceInput } from "react-debounce-input";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import Select from "react-select";
import { Button } from "react-bootstrap";
import SortIcon from "../../assets/images/expand_all.svg";
import moment from "moment";
import NotificationIcon from "../../assets/images/alert-notification.svg";

const ResellerTable = ({
  listData,
  dateRange,
  setDateRange,
  selectedFrequency,
  frequencyOptions,
  setSelectedFrequency,
  handleFilterClick,
  clearFilters,
  searchTerm,
  setSearchTerm,
  currentRows,
  setSortDirection,
  sortDirection,
  handleActionClick,
  filteredPaymentData,
  rowsPerPage,
  currentPage,
  totalPages,
  handleRowsPerPageChange,
  setCurrentPage,
}) => {
  function toSentenceCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  return (
    <>
      {" "}
      {listData.length > 0 ? (
        <div className="table-container">
          <div className="table-header">
            <h2>Client Payment Schedule Overview</h2>

            <div className="table-filters">
              <div className="table-filter_wrapper">
                <div className="date-range-wrapper">
                  <DatePicker
                    selected={dateRange[0]}
                    onChange={(dates) => {
                      setDateRange(dates);
                    }}
                    startDate={dateRange[0]}
                    endDate={dateRange[1]}
                    selectsRange
                    placeholderText="Upcoming Pay Dates"
                    className="form-control filter-select me-2"
                    dateFormat="MM/dd/yyyy"
                    isClearable={false}
                  />
                </div>

                <Select
                  value={
                    selectedFrequency !== ""
                      ? frequencyOptions.find(
                          (option) => option.label === selectedFrequency
                        )
                      : null
                  }
                  onChange={(option) =>
                    setSelectedFrequency(option?.label || "")
                  }
                  options={frequencyOptions.map((option) => ({
                    value: toSentenceCase(option.label),
                    label: toSentenceCase(option.label),
                  }))}
                  placeholder="Pay Frequency"
                  className="filter-select me-2"
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                />

                <Button
                  className="filter-button ms-1"
                  onClick={handleFilterClick}
                >
                  FILTER
                </Button>

                {(selectedFrequency || dateRange[0] || dateRange[1]) && (
                  <Button
                    className="filter-button outline ms-1"
                    onClick={clearFilters}
                    variant="outline-secondary"
                  >
                    CLEAR
                  </Button>
                )}
              </div>

              <div>
                <DebounceInput
                  type="text"
                  placeholder="Search"
                  className="search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  debounceTimeout={500}
                />
              </div>
            </div>
          </div>

          {currentRows.length > 0 ? (
            <div className="table-responsive-wrapper">
              <table className="payment-table">
                <thead>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() =>
                      setSortDirection((prev) =>
                        prev === "date" ? "asc" : "date"
                      )
                    }
                  >
                    <Tooltip
                      placement="top"
                      overlay={
                        <div style={{ wordBreak: "break-word" }}>
                          {sortDirection === "asc"
                            ? "Sort Alphabetically"
                            : "Sort by recent"}
                        </div>
                      }
                      overlayClassName="reseller-tooltip"
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        Client Name
                        <img
                          src={SortIcon}
                          alt="arrow-icon"
                          className={`arrow-icon ${
                            sortDirection === "asc" ? "arrow-rotate" : ""
                          }`}
                          style={{ marginLeft: "6px" }}
                        />
                      </span>
                    </Tooltip>
                  </th>
                  <th>Pay Frequency</th>
                  <th>Pay Period</th>
                  <th>Processing Status</th>
                  <th>Processing Date</th>
                  <th>Upcoming Pay Date</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <tr key={`${row.client_id}-${index}`}>
                      <td>
                        {row.status === 0 ? (
                          <span className="active-text">
                            {row.legal_name.length > 15 ? (
                              <Tooltip
                                placement="top"
                                overlay={
                                  <div style={{ wordBreak: "break-word" }}>
                                    {row.legal_name}
                                  </div>
                                }
                                overlayClassName="reseller-tooltip"
                              >
                                <span>
                                  {row.legal_name.substring(0, 15)}...
                                </span>
                              </Tooltip>
                            ) : (
                              <span>{row.legal_name}</span>
                            )}
                            <span className="reseller-status-text">
                              Inactive
                            </span>
                          </span>
                        ) : (
                          <a
                            href={`https://app.guhroo.co/clients/switch_client/${row.client_id}/reseller`}
                          >
                            {row.legal_name.length > 15 ? (
                              <Tooltip
                                placement="top"
                                overlay={
                                  <div style={{ wordBreak: "break-word" }}>
                                    {row.legal_name}
                                  </div>
                                }
                                overlayClassName="reseller-tooltip"
                              >
                                <span>
                                  {row.legal_name.substring(0, 15)}...
                                </span>
                              </Tooltip>
                            ) : (
                              <span>{row.legal_name}</span>
                            )}
                          </a>
                        )}
                      </td>
                      <td>
                        {row.pay_frequency.charAt(0).toUpperCase() +
                          row.pay_frequency.slice(1)}
                      </td>
                      <td>
                        {row.pay_period?.start_date && row.pay_period?.end_date
                          ? `${moment(row.pay_period.start_date).format(
                              "MM/DD/YYYY"
                            )} - ${moment(row.pay_period.end_date).format(
                              "MM/DD/YYYY"
                            )}`
                          : "-"}
                      </td>
                      <td>
                        {row.process_status.charAt(0).toUpperCase() +
                          row.process_status.slice(1)}
                      </td>
                      <td>
                        {moment(row.payroll_deadline).format("MM/DD/YYYY") ||
                          "Not Processed"}
                      </td>
                      <td>
                        {moment(row.upcoming_pay_date).format("MM/DD/YYYY") ??
                          "-"}
                      </td>
                      <td>
                        <button
                          className={`action-button ${
                            row.process_status === "processed" ? "disabled" : ""
                          }`}
                          onClick={() =>
                            row.process_status !== "processed" &&
                            handleActionClick(row)
                          }
                          disabled={row.process_status === "processed"}
                        >
                          <img
                            src={NotificationIcon}
                            alt="action"
                            style={{ height: "24px", width: "24px" }}
                          />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="table-responsive-wrapper">
              <table className="payment-table">
                <thead>
                  <th>Client Name</th>
                  <th>Pay Frequency</th>
                  <th>Pay Period</th>
                  <th>Processing Status</th>
                  <th>Processing Date</th>
                  <th>Upcoming Pay Date</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colSpan="7"
                      style={{ textAlign: "center", padding: "20px" }}
                      className="no-results"
                    >
                      No matching clients found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {filteredPaymentData.length > 0 && (
            <div className="pagination-container">
              <div className="pagination-controls">
                <div className="rows-per-page">
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                <div className="custom-pagination">
                  {currentPage > 1 && (
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      className="non-active-pagination-btn"
                    >
                      &lt;
                    </button>
                  )}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (page) => (
                      <button
                        key={page}
                        disabled={currentPage === page}
                        onClick={() => setCurrentPage(page)}
                        className={
                          currentPage === page
                            ? "active-pagination-btn"
                            : "non-active-pagination-btn"
                        }
                      >
                        {page}
                      </button>
                    )
                  )}
                  {currentPage < totalPages && (
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                      className="non-active-pagination-btn"
                    >
                      &gt;
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default ResellerTable;
